import { render, staticRenderFns } from "./dialogConfirmRedeemFinal.vue?vue&type=template&id=45a3596c"
import script from "./dialogConfirmRedeemFinal.vue?vue&type=script&lang=js"
export * from "./dialogConfirmRedeemFinal.vue?vue&type=script&lang=js"
import style0 from "./dialogConfirmRedeemFinal.vue?vue&type=style&index=0&id=45a3596c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports